<template>
  <div class="product-mockups" id="om-product-mockups" v-if="product">
    <div class="carousel_slider_box">
      <carousel
        :perPage="1"
        :paginationEnabled='false'
        v-if="sliderImages.length > 0"
        ref="carousel"
        id="om-product-carousels"
        @page-change='OnPageChange'
      >
        <slide
          v-for="(image, index) in sliderImages"
          :key="index"
          :data-index="index"
          :variant-ids="image.variant_ids"
          :is-render="isRender(index)"
        >
          <media
            :media="image"
            :index="index"
            paginationEnabled='false'
            @isrender="
              render => {
                slides[index] = render
                slides = [...slides]
              }
            "
          />
        </slide>
      </carousel>
      <LoadArThree
        :metaData="getArMeta"
        :legacyMetaData="getLegacyArMeta"
        :uuidAr="uuidChangeAr"
        :useViewArPersonalized="getUseViewArPersonalized"
        :arDisplay="getArDisplayOptions"
      />
    </div>

    <div class='group_pagination_product_media'>
      <div v-if='this.activeIndex > 0' class='group_pagination_product_media_prev'>
        <button @click='OnClickPrev' class='btn-pagination btn-prev'>
          &#10092;
        </button>
      </div>

      <div ref='pagination_box' class='group_pagination_product_media_imgs'>
        <div :ref="'domActive' + index " v-bind:class='{active: index == activeIndex}'  class='group_pagination_product_media_imgs_item' v-for="(image, index) in sliderImages">
          <div @click='OnChangeActiveIndex(index)'>
            <div v-if="image.type">
              <div v-if="image.type == 'video'" class="pagination_product_video_box">
                <div class="pagination_product_video_box__icon">
                  <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 22px; height: 22px;">
                    <path d="M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"/>
                  </svg>
                </div>
                <video width="100%" style="pointer-events: none;">
                  <source :src="image.src" type="video/mp4">
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <img v-else class='group_pagination_product_image' :arr-va-id="image.id" :alt='image.alt ? image.alt : "images variants"' :src='image.src' />
          </div>
        </div>
      </div>

      <div v-if='this.activeIndex < this.sliderImages.length - 1' class='group_pagination_product_media_next'>
        <button @click='OnClickNext' class='btn-pagination btn-next'>
          &#10093;
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Mockup from './Mockup/Mockup'
import Media from './Media/Media'
import { Carousel, Slide } from 'vue-carousel'
import { get } from 'lodash'
import jQuery from 'jquery'
import LoadArThree from './Media/LoadArThree.vue'

export default {
  components: {
    Mockup,
    Media,
    Carousel,
    Slide,
    LoadArThree
  },
  created() {
  },
  data() {
    return {
      slides: [],
      activeIndex: 0,
      isDragCarousel: true,
      uuidChangeAr: null
    }
  },
  mounted() {
    this.slides = this.sliderImages.map(() => false);
    this.goToVariantMedia(this.selectedVariant || '')
    if (this.platform === 'woocommerce') {
      jQuery('#om-product-mockups')
        .prev()
        .hide()
    }
  },
  watch: {
    selectedVariant(variantID) {
      if (variantID) {
        this.goToVariantMedia(variantID);
      }
    }
  },
  computed: {
    ...mapGetters(['platform', 'product', 'mockups', 'selectedVariant']),
    getArMeta(){
      const { meta_data } = this.product;
      let data = [];
      if(meta_data && Array.isArray(meta_data)){
        const find__viewer_ar_meta = meta_data.find(e => e.key == "_abnviewer_ar_results");
        if(find__viewer_ar_meta){
          if(find__viewer_ar_meta.value && Array.isArray(find__viewer_ar_meta.value) && find__viewer_ar_meta.value.length > 0){
            data = find__viewer_ar_meta.value;
          }
        }
      }
      return data;
    },
    // Old "_viewer_ar_meta" meta (pre-abn-ar-generator plugin): a JSON string
    // for a single flat asset { glb_url, img_url, link_3d_mobile }, no size
    // matching. Kept as the last-resort fallback for products that predate
    // both _abnviewer_ar_results and _use_viewAR_created_from_personalized.
    getLegacyArMeta(){
      const { meta_data } = this.product;
      let data = {};
      if(meta_data && Array.isArray(meta_data)){
        const find__viewer_ar_meta = meta_data.find(e => e.key == "_viewer_ar_meta");
        if(find__viewer_ar_meta){
          try {
            const parsed = JSON.parse(find__viewer_ar_meta.value);
            if(parsed){
              data = parsed;
            }
          } catch (error) {
            data = {};
          }
        }
      }
      return data;
    },
    getUseViewArPersonalized(){
      const { meta_data } = this.product;
      if(meta_data && Array.isArray(meta_data)){
        const found = meta_data.find(e => e.key == "_use_viewAR_created_from_personalized");
        if(found){
          return found.value;
        }
      }
      return false;
    },
    // Per-product AR display settings from the abn-ar-generator plugin's
    // product edit screen: hide the 360° / "View in my room" buttons and the
    // background color of the 3D view. Missing meta = button shown / no color.
    // The button switches and background color only apply while "Use AR
    // view created from Personalized" is on — the only time the admin shows them.
    getArDisplayOptions(){
      const { meta_data } = this.product;
      const getMeta = (key) => {
        if(meta_data && Array.isArray(meta_data)){
          const found = meta_data.find(e => e.key == key);
          if(found){
            return found.value;
          }
        }
        return null;
      };
      const isOn = (value) => value === true || value === 'true' || value === '1' || value === 1;
      const bgColor = getMeta("_abnviewer_ar_bg_color");
      const personalized = isOn(this.getUseViewArPersonalized);
      return {
        show360: !personalized || !isOn(getMeta("_abnviewer_ar_hide_360")),
        showRoom: !personalized || !isOn(getMeta("_abnviewer_ar_hide_room")),
        bgColor: (personalized && typeof bgColor === 'string' && /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(bgColor)) ? bgColor : null
      };
    },
    sliderImages(){
      const {images, meta_data, variants} = this.product;
      var idImageFirst = (Array.isArray(images) && images.length > 0) ? images[0].id : null;
      var datas = [];
       for(var a = 0; a < variants.length; a++){
        datas = [
          ...datas,
          {
            ...variants[a].image,
            variation_id: variants[a].id
          }
        ]
      }
      datas = [...datas,...images];
      try {
        if(meta_data && meta_data.length > 0){
          const find__slide_preview_video_meta = meta_data.find(e => e.key == '_slide_preview_video_meta');
          if(find__slide_preview_video_meta){
            const itemMetaVideo = find__slide_preview_video_meta;
            const itemMetaVideoJson = JSON.parse(itemMetaVideo.value);
              if(itemMetaVideoJson.url){
                const newItem = {
                  "alt": "",
                  "id": itemMetaVideoJson.id,
                  "name": itemMetaVideoJson.id,
                  "src": itemMetaVideoJson.url,
                  "variant_ids": [],
                  type: 'video'
                }
                datas = [...datas, newItem];
              }
          }
        }
      } catch (error) {

      }
      datas = this.uniqueByIdWithPriority([...datas]);
      if(idImageFirst){
        datas = this.moveItemToFront([...datas], idImageFirst);
      }
      return datas.filter(e => e.src);
    }
  },
  methods: {
    moveItemToFront(array, targetId) {
      const index = array.findIndex(item => item.id === targetId);
      if (index === -1) return array; // Không tìm thấy => trả lại nguyên mảng

      const [targetItem] = array.splice(index, 1); // Xóa item khỏi vị trí cũ
      array.unshift(targetItem); // Thêm vào đầu mảng
      return array;
    },
    uniqueByIdWithPriority(items) {
      const map = new Map();
      for (const item of items) {
        const existing = map.get(item.id);
        if (!existing) {
          map.set(item.id, item);
        } else {
          const keepCurrent = item.variation_id && !existing.variation_id;
          if (keepCurrent) {
            map.set(item.id, item);
          }
        }
      }

      return Array.from(map.values());
    },
    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    goToVariantMedia(variantID = '') {
      const { product, platform, sliderImages } = this
      if (sliderImages.length <= 1) {
        return
      }
      const {
        product: { images = [] }
      } = this
      if (platform === 'shopify') {
        images.forEach((image, i) => {
          const { variant_ids = [] } = image
          if (
            variant_ids.map(id => id.toString()).includes(variantID.toString())
          ) {
            this.activeIndex = i;
            this.$refs.carousel.goToPage(i)
          }
        })
      }
      if (platform === 'woocommerce') {
        const variant = product.variants.find(
          v => v.id.toString() === variantID.toString()
        )
        if (variant && variant.image) {
          images.forEach((image, i) => {
            if (image.id === variant.image.id) {
              this.activeIndex = i;
              this.$refs.carousel.goToPage(i)
            }
          })
        }
      }
    },
    OnChangeActiveIndex(i){
      this.uuidChangeAr = this.uuidv4();
      this.activeIndex = i;
      this.$refs.carousel.goToPage(i)
    },
    OnPageChange(i){
      this.activeIndex = i;
      this.ScrollView();
    },
    ScrollView(){
      const ItemActive = this.$refs['domActive'+this.activeIndex][0];
      this.$refs.pagination_box.scrollLeft = ItemActive.offsetLeft - 30 ;
    },
    OnClickPrev(){
      if(this.activeIndex > 0){
        this.activeIndex = this.activeIndex - 1;
        this.$refs.carousel.goToPage(this.activeIndex);
        this.ScrollView();
      }
    },
    OnClickNext(){
      if(this.activeIndex < this.sliderImages.length - 1){
        this.activeIndex = this.activeIndex + 1;
        this.$refs.carousel.goToPage(this.activeIndex);
        this.ScrollView();
      }
    },
    isRender(index) {
      return get(this.slides, [index], false) ? 1 : 0
    }
  }
}
</script>


<style scoped>
  .group_pagination_product_image{
    width: 100%;
  }
  .group_pagination_product_media{
    width: 100%;
    display: flex;
    margin-top: 7px;
    position: relative;
    margin-bottom: 10px;
  }
  .group_pagination_product_media_imgs{
    width: 100%;
    display: -webkit-box;
    overflow: auto;
    padding: 5px 0;
  }
  .group_pagination_product_media_imgs::-webkit-scrollbar {
    display: none !important;
  }
  .group_pagination_product_media_imgs::-webkit-scrollbar-thumb {
    display: none !important;
  }
  .group_pagination_product_media > div{
    padding: 5px 0;
  }

  .group_pagination_product_media_imgs::-webkit-scrollbar {
    width: 6px;
    height: 4px;
    background-color: #F5F5F5;
  }
  .group_pagination_product_media_imgs::-webkit-scrollbar-thumb {
    background-color: #868686;
  }
  .group_pagination_product_media_imgs_item{
    width: 133px;
    height: 133px;
    margin-right: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f5;
    border-radius: 2px;
    cursor: pointer;
    opacity: 0.4;
    transition: 0.6s;
  }
  .group_pagination_product_media_imgs_item:hover{
    opacity: 1;
  }
  .group_pagination_product_media_imgs_item.active{
    box-shadow: 0px 0px 2px 1px #464646;
    opacity: 1;
  }
  .group_pagination_product_media_prev {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: stretch;
    z-index: 1000;
    transition: 0.7s;
  }
  .group_pagination_product_media_next{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: stretch;
    z-index: 1000;
    transition: 0.7s;
  }
  button.btn-pagination {
    border: none;
    background: rgba(74, 70, 70, 0.1);
    color: #383838;
    display: none;
    transition: 0.7s;
  }
  .group_pagination_product_media:hover button.btn-pagination{
    display: block;
  }
  .pagination_product_video_box__icon {
    position: absolute;
    width: 25px;
    right: 5px;
    top: 5px;
  }
  .pagination_product_video_box__icon svg{
    fill: #555555;
  }
  .pagination_product_video_box {
      position: relative;
  }
  @media only screen and (max-width: 48em){
    .group_pagination_product_media_imgs_item{
      width: 90px;
      height: 90px;
    }
    button.btn-pagination {
      display: block;
    }
  }
</style>

<style>
.omcustom-product-image{
  height:100%;
  overflow:hidden;
  width: 100%;
  align-items: center;
  background: rgba(0, 0, 0, 0.04);
  position: relative;
}
.expand-btn-show svg{
  fill: #555555;
}
.omcustom-product-image > img{
  /*width: auto;*/
}
.carousel_slider_box {
  position: relative;
}
.action_viewer_ar_product__box{
  position: absolute;
  z-index: 999;
  bottom: 0;
  right: 0;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.action_viewer_ar_product__box_btn{
  margin: 0px;
  margin-bottom: 0px !important;
  outline: none;
  border: none;
  /* width: 65px; */
  padding: 5px 10px;
  border-radius: 20px;
  box-shadow: 0px 2px 4px -1px #333;
  background: #fff;
  transition: 0.6s;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  font-size: 15px;
  font-family: system-ui;
  font-weight: 600;
  color: #333;
  overflow: hidden;
  white-space: nowrap;
}
.action_viewer_ar_product__box img{
  width: 45px;
}
.action_viewer_ar_product__box_btn:hover {
    background: #ededed;
    transition: 0.6s;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductMedia.vue